import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import LeaseRow from 'components/comps/table/lease_row';
import { filterLiteCrmContactColumns } from '../helpers';
import { toggleSelectLease } from '../store/actions/select_list';

const LeaseRowContainer = ({ currentColumns, edgeCrm, ...props }) => {
  const columns = edgeCrm
    ? filterLiteCrmContactColumns(currentColumns)
    : currentColumns;

  return (
    <LeaseRow
      {...props}
      currentColumns={columns}
      edgeCrm={edgeCrm}
    />
  );
};

LeaseRowContainer.propTypes = {
  currentColumns: PropTypes.array.isRequired,
  currentUser: PropTypes.object.isRequired,
  edgeCrm: PropTypes.bool,
  lease: PropTypes.object.isRequired,
  selected: PropTypes.bool,
  onSelect: PropTypes.func
};

const mapStateToProps = state => ({
  currentColumns: state.session.currentLeaseColumns,
  currentUser: state.scope.currentUser,
  customFieldSchemas: state.customFieldSchemas,
  edgeCrm: state.features.edgeCrm,
});

const mapDispatchToProps = {
  onSelect: toggleSelectLease
};

export default connect(mapStateToProps, mapDispatchToProps)(LeaseRowContainer);
